export default __webpack_public_path__ + "static/media/fac.d00064d8.jpeg";